import type { JourneyEventName } from '~/constants/journeyEvents'

/**
 * Records the steps of the CV funnel that the server never sees on its own
 * (see constants/journeyEvents.ts), and hands out the browser's analytics id so
 * the server can stamp it on the rows it does write. Both end up side by side
 * in /admin/journeys.
 *
 * Take it in setup: the events usually fire from a click handler after an await.
 */
export function useJourney() {
  const analytics = useAnalytics()

  /** The browser's analytics id, or null with tracking switched off. */
  function visitorId(): string | null {
    if (!import.meta.client || !analytics.isTrackingEnabled()) return null
    try {
      return analytics.getVisitorId()
    } catch {
      return null // storage blocked
    }
  }

  function track(name: JourneyEventName, data: Record<string, unknown> = {}) {
    if (!import.meta.client) return
    analytics.trackCustomEvent(name, data).catch(() => {})
  }

  return { visitorId, track }
}
